export default "__VITE_ASSET__DrHLcYkn__"